import { FC } from 'react';

import { CheckCheck } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';

import { userService } from 'v2/api/userService';
import { FingerprintModel } from 'v2/types/FingerprintModel';
import { handleHttpError } from 'v2/utils';

interface SuspiciousUsersActionsColumnProps {
  fingerprint: FingerprintModel;
  onRevalidate: VoidFunction;
}

export const SuspiciousUsersActionsColumn: FC<SuspiciousUsersActionsColumnProps> = ({ fingerprint, onRevalidate }) => {
  const { trigger, isMutating } = useSWRMutation(
    ['checkFingerprint', fingerprint.fingerprintId],
    userService.checkFingerprint,
    {
      onSuccess: () => {
        onRevalidate();
        toast.success('User checked');
      },
      onError: handleHttpError,
    }
  );

  const handleCheck = () => {
    trigger();
  };

  return fingerprint.isChecked ? (
    <Chip size="small" label="User Checked" color="success" />
  ) : (
    <Button onClick={handleCheck} loading={isMutating} startIcon={<CheckCheck width={18} />} variant="outlined">
      Check User
    </Button>
  );
};
